import React, { PureComponent } from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import { CSS_CLASS_PREFIX } from "../../constants/css";
import { cssMainSelector } from "../../lib/cssSelectors";
import { withTranslation } from "react-i18next";

const Container = styled.div`
  ${p => cssMainSelector(p.theme.tdsId)} {
    padding-bottom: ${p => p.theme.spacing.md};
  }
`;

const Title = styled.div`
  ${p => cssMainSelector(p.theme.tdsId)} {
    font-weight: ${p => p.theme.font.weightBold};
    padding-bottom: ${p => p.theme.spacing.md};
  }
`;

const radioButtonContainerLabel1 = `label:hover input ~ .${CSS_CLASS_PREFIX}-checkmark-border .${CSS_CLASS_PREFIX}-checkmark`;
const radioButtonContainerLabel2 = `label input:checked ~ .${CSS_CLASS_PREFIX}-checkmark-border .${CSS_CLASS_PREFIX}-checkmark`;
const radioButtonContainerLabel3 = `label input:checked ~ .${CSS_CLASS_PREFIX}-checkmark-border .${CSS_CLASS_PREFIX}-checkmark:after`;
const RadioButtonContainer = styled.div`
  ${p => cssMainSelector(p.theme.tdsId)} {
  
    * {
      box-sizing: content-box;
    }
    
    label {
      box-sizing: content-box;
      cursor: pointer;
      display: block;
      font-size: ${p => p.theme.font.size};
      margin-bottom: ${p => p.theme.spacing.sm};
      padding-left: 22px;
      position: relative;
      user-select: none;

      input {
        cursor: pointer;
        opacity: 0;
        position: absolute;
      }
    }
    
    ${radioButtonContainerLabel1} {
      background-color: ${p =>
        p.theme.filter.radioButtonList.hoverBackgroundColor};
      box-sizing: content-box;
    }

    ${radioButtonContainerLabel2} {
      background-color: ${p =>
        p.theme.filter.radioButtonList.checkedBackgroundColor};
      box-sizing: content-box;
    }

    ${radioButtonContainerLabel3} {
      box-sizing: content-box;
      display: block;
    }
  }
`;

const CheckmarkBorder = styled.span`
  ${p => cssMainSelector(p.theme.tdsId)} {
    border: solid;
    border-color: ${p => p.theme.filter.radioButtonList.borderColor};
    border-radius: 50%;
    border-width: 1px;
    height: 14px;
    left: 0;
    position: absolute;
    top: 0;
    width: 14px;
  }
`;

const Checkmark = styled.span`
  ${p => cssMainSelector(p.theme.tdsId)} {
    background-color: ${p => p.theme.color.white};
    border-radius: 50%;
    height: 14px;
    left: 0;
    position: absolute;
    top: 0;
    width: 14px;

    :after {
      background-color: ${p => p.theme.filter.radioButtonList.checkColor};
      border-radius: 50%;
      content: "";
      display: none;
      height: 8px;
      left: 3px;
      position: absolute;
      top: 3px;
      width: 8px;
    }
  }
`;

class RadioButtonListFilter extends PureComponent {
  render() {
    const { title } = this.props;

    return (
      <Container>
        <Title>{title}</Title>
        <RadioButtonContainer>{this.radioButtons()}</RadioButtonContainer>
      </Container>
    );
  }

  radioButtons() {
    const { onChange, value, values } = this.props;
    const radioButtons = [];

    for (const [radioButtonValue, radioButtonLabel] of values) {
      radioButtons.push(
        <label key={radioButtonValue}>
          {radioButtonLabel}
          <input
            type="radio"
            checked={value === radioButtonValue.toString()}
            onChange={onChange}
            value={radioButtonValue}
          />
          <CheckmarkBorder className={`${CSS_CLASS_PREFIX}-checkmark-border`}>
            <Checkmark className={`${CSS_CLASS_PREFIX}-checkmark`} />
          </CheckmarkBorder>
        </label>
      );
    }

    return radioButtons;
  }
}

RadioButtonListFilter.propTypes = {
  onChange: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired,
  value: PropTypes.string,
  values: PropTypes.array.isRequired
};

export default withTranslation(["filters"])(RadioButtonListFilter);
